import { AsyncPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import {
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxButtonComponent,
  OnyxDatepickerComponent,
  onyxDateValidator,
  OnyxDropdownComponent,
  OnyxIconButtonComponent,
  OnyxSectionComponent,
  OnyxUploadComponent,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../common/enums/dictionary-code';
import { DictionariesService } from '../../../../common/services/dictionaries.service';

type DriverVisasFormGroup = ReturnType<
  typeof DriverVisasFormComponent.buildForm
>;

type DriverVisaFormGroup = ReturnType<
  typeof DriverVisasFormComponent.buildVisaForm
>;

@Component({
  selector: 'app-driver-visas-form',
  imports: [
    OnyxSectionComponent,
    TranslatePipe,
    OnyxButtonComponent,
    ReactiveFormsModule,
    OnyxDropdownComponent,
    AsyncPipe,
    OnyxDatepickerComponent,
    OnyxUploadComponent,
    OnyxIconButtonComponent,
  ],
  templateUrl: './driver-visas-form.component.html',
  styleUrl: './driver-visas-form.component.scss',
})
export class DriverVisasFormComponent {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly dictionariesService = inject(DictionariesService);

  public readonly form = input.required<DriverVisasFormGroup>();

  protected readonly I18N = 'drivers.driverForm.visas';

  protected readonly countries$ = this.dictionariesService.getDictionary(
    DictionaryCode.COUNTRY,
  );

  protected addVisa(): void {
    this.form().push(DriverVisasFormComponent.buildVisaForm(this.fb));
  }

  protected removeVisa(index: number): void {
    this.form().removeAt(index);
  }

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.array<DriverVisaFormGroup>([]);
  }

  public static buildVisaForm(fb: NonNullableFormBuilder) {
    return fb.group({
      country: fb.control<string | null>(null, [Validators.required]),
      expirationDate: fb.control<string | null>(null, [
        Validators.required,
        onyxDateValidator,
      ]),
      scans: fb.control<string[]>([]),
    });
  }
}
